"use client"

import { useState, useEffect } from "react"
import "../styles/DogForm.css"

const healthConditionOptions = [
  { id: "obesity", label: "Obesity/Weight Management" },
  { id: "allergies", label: "Food Allergies/Sensitivities" },
  { id: "joints", label: "Joint Issues/Arthritis" },
  { id: "digestion", label: "Digestive Issues" },
  { id: "dental", label: "Dental Problems" },
  { id: "kidney", label: "Kidney Issues" },
  { id: "heart", label: "Heart Conditions" },
]

function DogForm({ onSubmit, initialData }) {
  const [formData, setFormData] = useState({
    breed: "",
    age: "",
    weight: "",
    healthConditions: [],
  })

  // Update form with initial data when available
  useEffect(() => {
    if (initialData) {
      setFormData(initialData)
    }
  }, [initialData])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleHealthConditionChange = (e) => {
    const { value, checked } = e.target

    setFormData((prev) => {
      if (checked) {
        return {
          ...prev,
          healthConditions: [...prev.healthConditions, value],
        }
      } else {
        return {
          ...prev,
          healthConditions: prev.healthConditions.filter((condition) => condition !== value),
        }
      }
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <div className="form-container">
      <h2>Find the Perfect Food for Your Dog</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="breed">Dog Breed:</label>
          <input
            type="text"
            id="breed"
            name="breed"
            value={formData.breed}
            onChange={handleChange}
            placeholder="e.g., Golden Retriever"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="age">Age (years):</label>
            <input
              type="number"
              id="age"
              name="age"
              min="0.1"
              step="0.1"
              value={formData.age}
              onChange={handleChange}
              placeholder="e.g., 2"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="weight">Weight (kg):</label>
            <input
              type="number"
              id="weight"
              name="weight"
              min="0.5"
              step="0.5"
              value={formData.weight}
              onChange={handleChange}
              placeholder="e.g., 25"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Health Conditions (if any):</label>
          <div className="health-conditions-grid">
            {healthConditionOptions.map((condition) => (
              <div key={condition.id} className="checkbox-item">
                <input
                  type="checkbox"
                  id={condition.id}
                  name="healthConditions"
                  value={condition.id}
                  checked={formData.healthConditions.includes(condition.id)}
                  onChange={handleHealthConditionChange}
                />
                <label htmlFor={condition.id}>{condition.label}</label>
              </div>
            ))}
          </div>
        </div>

        <button type="submit" className="submit-button">
          Get Recommendations
        </button>
      </form>
    </div>
  )
}

export default DogForm

